export const languagesRegex = /en|fr|de|pt|es|hr|hu|it|nl|pl|tr|uk|cs|ru|ro|sk/;

export const languagesArray = ['en', 'fr', 'de', 'pt', 'es', 'hr', 'hu', 'it', 'nl', 'pl', 'tr', 'uk', 'cs', 'ru', 'ro', 'sk'];

export const languagesMapped = [
  {
    code: 'cs',
    language: 'Český',
  },
  {
    code: 'de',
    language: 'Deutsch',
  },
  {
    code: 'en',
    language: 'English',
  },
  {
    code: 'es',
    language: 'Español',
  },
  {
    code: 'fr',
    language: 'Français',
  },
  {
    code: 'hr',
    language: 'Hrvatski',
  },
  {
    code: 'it',
    language: 'Italiano',
  },
  {
    code: 'hu',
    language: 'Magyar',
  },
  {
    code: 'nl',
    language: 'Nederlands',
  },
  {
    code: 'pl',
    language: 'Polski',
  },
  {
    code: 'pt',
    language: 'Português',
  },
  {
    code: 'ru',
    language: 'Русский',
  },
  {
    code: 'ro',
    language: 'Română',
  },
  {
    code: 'sk',
    language: 'Slovenský',
  },
  {
    code: 'tr',
    language: 'Türkçe',
  },
  {
    code: 'uk',
    language: 'Yкраїнська мова',
  },
];

export enum LanguageCodes {
  en = 'en',
  fr = 'fr_FR',
  cs = 'cs_CZ',
  de = 'de',
  pt = 'pt',
  es = 'es',
  hr = 'hr',
  hu = 'hu',
  it = 'it',
  nl = 'nl',
  pl = 'pl',
  tr = 'tr',
  uk = 'uk',
  ru = 'ru',
  ro = 'ro',
  sk = 'sk',
}
